import { Box, Divider, Stack } from '@mui/material';

import AttendanceRouter from './AttendanceRouter';
import { AttendancePageContextProvider } from './Context';
import Header from './Header';

const AttendancePageLayout = () => {
  return (
    <Stack gap={4} px={4} py={2} height="100%">
      <Header />
      <Divider />
      <Box flex={1} p={2}>
        <AttendanceRouter />
      </Box>
    </Stack>
  );
};

const AttendancePage = () => {
  return (
    <AttendancePageContextProvider>
      <AttendancePageLayout />
    </AttendancePageContextProvider>
  );
};

export default AttendancePage;
